var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18162 4.18162C3.94731 3.9473 3.56473 3.94558 3.35497 4.20211C2.48258 5.26903 2 6.60963 2 8C2 9.39036 2.48258 10.731 3.35497 11.7979C3.56473 12.0544 3.94731 12.0527 4.18162 11.8184C4.41594 11.5841 4.41246 11.2062 4.20918 10.9445C3.55853 10.1068 3.2 9.07189 3.2 8C3.2 6.9281 3.55853 5.89317 4.20918 5.05553C4.41246 4.79383 4.41594 4.41593 4.18162 4.18162Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L10 5.5M8 8L6 10.5M8 8L7 6C6.79399 5.58798 6.20601 5.58798 6 6M8 8L9 10C9.20601 10.412 9.79399 10.412 10 10",
    stroke: "#002A69",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8188 11.8184C12.0531 12.0527 12.4357 12.0544 12.6454 11.7979C13.016 11.3447 13.3189 10.8389 13.5437 10.2961C13.8452 9.56814 14.0004 8.78793 14.0004 8C14.0004 7.21206 13.8452 6.43185 13.5437 5.70389C13.3189 5.1611 13.016 4.65528 12.6454 4.20211C12.4357 3.94557 12.0531 3.9473 11.8188 4.18162C11.5845 4.41593 11.5879 4.79383 11.7912 5.05553C12.0538 5.39359 12.2705 5.76598 12.435 6.16312C12.6763 6.74548 12.8004 7.36965 12.8004 8C12.8004 8.63034 12.6763 9.25451 12.435 9.83688C12.2705 10.234 12.0538 10.6064 11.7912 10.9445C11.5879 11.2062 11.5845 11.5841 11.8188 11.8184Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariable);
export default __webpack_public_path__ + "static/media/Variable.6da93ef9b0f77adc065c96aed7411474.svg";
export { ForwardRef as ReactComponent };